var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.24672C0 2.97838 2.68871 0.333344 6 0.333344C9.31129 0.333344 12 2.97838 12 6.24672C12 7.86111 11.3396 9.37312 10.1967 10.4729L6.46756 14.1419C6.20812 14.3971 5.79192 14.3972 5.53247 14.1419L1.79823 10.4683C0.656294 9.36394 0 7.85612 0 6.24672ZM9.26687 9.51729C10.1571 8.66064 10.6667 7.49394 10.6667 6.24672C10.6667 3.7197 8.57975 1.66668 6 1.66668C3.42025 1.66668 1.33333 3.7197 1.33333 6.24672C1.33333 7.49011 1.83976 8.65361 2.72922 9.51384L5.99997 12.7315L9.26687 9.51729ZM6 9.00001C7.47276 9.00001 8.66667 7.8061 8.66667 6.33334C8.66667 4.86058 7.47276 3.66668 6 3.66668C4.52724 3.66668 3.33333 4.86058 3.33333 6.33334C3.33333 7.8061 4.52724 9.00001 6 9.00001ZM6 7.66668C5.26362 7.66668 4.66667 7.06972 4.66667 6.33334C4.66667 5.59696 5.26362 5.00001 6 5.00001C6.73638 5.00001 7.33333 5.59696 7.33333 6.33334C7.33333 7.06972 6.73638 7.66668 6 7.66668Z",
    fill: "#002760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a3e4ec87b7e436289dd37995d7438b9a.svg";
export { ForwardRef as ReactComponent };